/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type { CancelOrderLib, CancelOrderLibInterface } from '../../MerkleOrderBookTemplate.sol/CancelOrderLib';

const _abi = [
  {
    inputs: [],
    name: 'InvalidCancelOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidNextOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidPrevOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidSigner',
    type: 'error',
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'cancelOrder',
            type: 'tuple',
          },
          {
            internalType: 'bytes',
            name: 'cancelOrderSignature',
            type: 'bytes',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'nextOrder',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'prevOrder',
            type: 'tuple',
          },
        ],
        internalType: 'struct CancelOrderReq',
        name: 'req',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'cancelOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'cancelOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'cancelOrderCancelDigest',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'nextOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'nextOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'prevOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'prevOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'OrdersRoot',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'head',
            type: 'bytes32',
          },
        ],
        internalType: 'struct CancelOrderAppend',
        name: 'append',
        type: 'tuple',
      },
    ],
    name: '_cancelMakeOrder',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'nextOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'prevOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'head',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'ordersRoot',
            type: 'bytes32',
          },
        ],
        internalType: 'struct CancelOrderRes',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
];

const _bytecode =
  '0x6115f961003a600b82828239805160001a60731461002d57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600436106100355760003560e01c8063900fd2011461003a575b600080fd5b61004d610048366004611223565b610089565b60405161008091908151815260208083015190820152604080830151908201526060918201519181019190915260800190565b60405180910390f35b60408051608081018252600080825260208201819052918101829052606081019190915273__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d6100d18580611303565b6100df9060c0810190611341565b6100e98780611303565b6100fb9061010081019060e0016113a9565b6101058880611303565b60000160a0013587602001518860e001516040518763ffffffff1660e01b81526004016101379695949392919061141b565b602060405180830381865af4158015610154573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906101789190611465565b6101ae576040517faf1d2c5500000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6101bb6020840184611482565b159050610294576101cc8380611303565b6101da9060208101906114e7565b73ffffffffffffffffffffffffffffffffffffffff1661024283604001518580602001906102089190611482565b8080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250610def92505050565b73ffffffffffffffffffffffffffffffffffffffff161461028f576040517f815e1d6400000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6102e5565b61029e8380611303565b6102af90606081019060400161151d565b6102e5576040517faf1d2c5500000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60408051608081018252606080850151825260a085015160208301526101008501519282019290925260e0840151918101919091526103248480611303565b61033590604081019060200161151d565b1561089357826020015183610100015114156104c257825161035d57600060408201526107bb565b61036a6040850185611303565b835160a090910135146103a9576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d6103d06040870187611303565b6103de9060c0810190611341565b6103eb6040890189611303565b6103fd9061010081019060e0016113a9565b61040a60408a018a611303565b60000160a0013588608001518960e001516040518763ffffffff1660e01b815260040161043c9695949392919061141b565b602060405180830381865af4158015610459573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061047d9190611465565b6104b3576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b608083015160408201526107bb565b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d6104e96060870187611303565b6104f79060c0810190611341565b6105046060890189611303565b6105169061010081019060e0016113a9565b61052360608a018a611303565b60000160a001358860c001518960e001516040518763ffffffff1660e01b81526004016105559695949392919061141b565b602060405180830381865af4158015610572573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105969190611465565b6105cc576040517fda9d3eba00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6105d68480611303565b60a08481015191013514610616576040517fda9d3eba00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6106236040850185611303565b835160a09091013514610662576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60006106716040860186611303565b61067f9060208101906114e7565b73ffffffffffffffffffffffffffffffffffffffff16146107a45773__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d6106c16040870187611303565b6106cf9060c0810190611341565b6106dc6040890189611303565b6106ee9061010081019060e0016113a9565b6106fb60408a018a611303565b60000160a0013588608001518960e001516040518763ffffffff1660e01b815260040161072d9695949392919061141b565b602060405180830381865af415801561074a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061076e9190611465565b6107a4576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6107b16040850185611303565b60a0013560208201525b73__$228f495fb21f6bb55c754ccea856a59eef$__639912fa776107df8680611303565b6107ed9060c0810190611341565b6107f78880611303565b6108099061010081019060e0016113a9565b6108138980611303565b60000160a00135600089602001518a60e001516040518863ffffffff1660e01b8152600401610848979695949392919061153a565b602060405180830381865af4158015610865573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610889919061157b565b6060820152610de8565b82602001518361010001511415610a1b5782516108b65760006040820152610d14565b6108c36040850185611303565b835160a09091013514610902576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d6109296040870187611303565b6109379060c0810190611341565b6109446040890189611303565b6109569061010081019060e0016113a9565b61096360408a018a611303565b60000160a0013588608001518960e001516040518763ffffffff1660e01b81526004016109959695949392919061141b565b602060405180830381865af41580156109b2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109d69190611465565b610a0c576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60808301516040820152610d14565b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d610a426060870187611303565b610a509060c0810190611341565b610a5d6060890189611303565b610a6f9061010081019060e0016113a9565b610a7c60608a018a611303565b60000160a001358860c001518960e001516040518763ffffffff1660e01b8152600401610aae9695949392919061141b565b602060405180830381865af4158015610acb573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610aef9190611465565b610b25576040517fda9d3eba00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b610b2f8480611303565b60a08481015191013514610b6f576040517fda9d3eba00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b610b7c6040850185611303565b835160a09091013514610bbb576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6000610bca6040860186611303565b610bd89060208101906114e7565b73ffffffffffffffffffffffffffffffffffffffff1614610cfd5773__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d610c1a6040870187611303565b610c289060c0810190611341565b610c356040890189611303565b610c479061010081019060e0016113a9565b610c5460408a018a611303565b60000160a0013588608001518960e001516040518763ffffffff1660e01b8152600401610c869695949392919061141b565b602060405180830381865af4158015610ca3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cc79190611465565b610cfd576040517f9186ce1800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b610d0a6040850185611303565b60a0013560208201525b73__$228f495fb21f6bb55c754ccea856a59eef$__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';

type CancelOrderLibConstructorParams =
  | [linkLibraryAddresses: CancelOrderLibLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: CancelOrderLibConstructorParams): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  );
};

export class CancelOrderLib__factory extends ContractFactory {
  constructor(...args: CancelOrderLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, CancelOrderLib__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = 'CancelOrderLib';
  }

  static linkBytecode(linkLibraryAddresses: CancelOrderLibLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$228f495fb21f6bb55c754ccea856a59eef\\$__', 'g'),
      linkLibraryAddresses['contracts/imports/SMT.sol:SMT'].replace(/^0x/, '').toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(overrides?: Overrides & { from?: PromiseOrValue<string> }): Promise<CancelOrderLib> {
    return super.deploy(overrides || {}) as Promise<CancelOrderLib>;
  }
  override getDeployTransaction(overrides?: Overrides & { from?: PromiseOrValue<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): CancelOrderLib {
    return super.attach(address) as CancelOrderLib;
  }
  override connect(signer: Signer): CancelOrderLib__factory {
    return super.connect(signer) as CancelOrderLib__factory;
  }
  static readonly contractName: 'CancelOrderLib';

  public readonly contractName: 'CancelOrderLib';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CancelOrderLibInterface {
    return new utils.Interface(_abi) as CancelOrderLibInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): CancelOrderLib {
    return new Contract(address, _abi, signerOrProvider) as CancelOrderLib;
  }
}

export interface CancelOrderLibLibraryAddresses {
  ['contracts/imports/SMT.sol:SMT']: string;
}
